export default __webpack_public_path__ + "static/media/completed.61eb2cc4.jpg";